/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_None_ReasonInputs */

const en_tourhelp_none_reason = /** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tours for this page are being added.`)
};

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const ar_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const he_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const ur_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const es_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const fr_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const de_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const pt_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const hi_tourhelp_none_reason = en_tourhelp_none_reason;

/** @type {(inputs: Tourhelp_None_ReasonInputs) => LocalizedString} */
const bn_tourhelp_none_reason = en_tourhelp_none_reason;

/**
* | output |
* | --- |
* | "Tours for this page are being added." |
*
* @param {Tourhelp_None_ReasonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_none_reason = /** @type {((inputs?: Tourhelp_None_ReasonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_None_ReasonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_none_reason(inputs)
	if (locale === "he") return he_tourhelp_none_reason(inputs)
	if (locale === "ur") return ur_tourhelp_none_reason(inputs)
	if (locale === "es") return es_tourhelp_none_reason(inputs)
	if (locale === "fr") return fr_tourhelp_none_reason(inputs)
	if (locale === "de") return de_tourhelp_none_reason(inputs)
	if (locale === "pt") return pt_tourhelp_none_reason(inputs)
	if (locale === "hi") return hi_tourhelp_none_reason(inputs)
	if (locale === "bn") return bn_tourhelp_none_reason(inputs)
	return /** @type {LocalizedString} */ ("Tours for this page are being added.")
});